import React from 'react';

export default function SupplierLocation({ city, state, country }) {
  const flag = country ? `${country}.svg` : 'default.svg';

  return (
    <p className="supplierCardLocation">
      <img src={`/icons/countries/${flag}`} alt={country} className="mr-2" />
      <span>
        {city && `${city}, `} {state && `${state}, `} {country}
      </span>
    </p>
  );
}
